import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "../../../utils";

export const studentExamAnswer = createAsyncThunk('studentExamAnswer', async ({ exam_id, question_id, selected_option_ids, answer_status, navigate }) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + `student_exam_answer`,
            data: {
                exam_id,
                question_id,
                selected_option_ids,
                answer_status,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const studentExamAnswerSlice = createSlice({
    name: 'studentExamAnswer',
    initialState: { data: null },
    extraReducers: (builder) => {
        builder.addCase(studentExamAnswer.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401 && !action.meta.arg?.silent) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = null
            }
        });
    }
})

export default studentExamAnswerSlice.reducer;
